module.exports = {
      id: "play-usage",
      viewBox: "0 0 30.542 30.542",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#play",
      toString: function () {
        return this.url;
      }
    }